import React from 'react';
import FormErrors from "./form_errors";
import {_t} from "../../../js/app/common/utils/locale";

export default class FormCheckbox extends React.Component {

    render() {
        return (
            <div className="cluster__form-group">
                <div className="form-group">
                    <div className={'custom-control custom-checkbox ' + (this.props.errors ? 'is-invalid' : '')}>
                        <input
                            type="checkbox"
                            className="custom-control-input"
                            id={this.props.name}
                            name={this.props.name}
                            onChange={this.props.onChange}
                            defaultChecked={this.props.checked}
                        />
                        <label className="custom-control-label" htmlFor={this.props.name} dangerouslySetInnerHTML={{__html: _t(this.props.label, this.props.labelData)}} />
                    </div>
                    <FormErrors errors={this.props.errors} />
                </div>
            </div>
        );
    }

}